import './App.less';
import { connect } from 'react-redux';
import { useState, useEffect } from 'react';
import Sidebar from './layout/Sidebar';
import Headers from './layout/Headers';
import Breadcremb from './layout/Breadcremb';

import microApp from './registerMicroApp';
import { useHistory } from 'react-router-dom';
import { openView } from './share/zeusRouter';

import { ConfigProvider } from 'antd'; // 引入ConfigProvider全局化配置
import zhCN from 'antd/es/locale/zh_CN'; // 引入中文包

function App(props) {
	// 判断特殊路径，用于处理内边距
	const specialPage =
		window.location.pathname === '/zeus-system/system-permissions/workingPlatform' ||
		window.location.pathname === '/zeus-system/system-permissions/Home' ||
		window.location.pathname === '/zeus-system/system-permissions/oaCenter' ||
		window.location.pathname === '/zeus-system/bank-manager-pc/salesManagement' ||
		window.location.pathname === '/zeus-system/bank-manager-pc/IntentionManagementDetail' ||
		window.location.pathname === '/zeus-system/bank-manager-pc/supplierManagementAdd' ||
		window.location.pathname === '/zeus-system/Outsourcing/ClueManagementDetail' ||
    window.location.pathname === '/zeus-system/Outsourcing/flowUpManagement' ||
    window.location.pathname === '/zeus-system/registered-audit-manager/agentWorkbench';
    
	const isShowFlow =
		window.location.pathname === '/zeus-system/bank-manager-pc/supplierManagementAdd' ||
		window.location.pathname === '/zeus-system/Outsourcing/ClueManagementDetail' ||
		window.location.pathname === '/zeus-system/Outsourcing/flowUpManagement';
	const history = useHistory();
	const [pathname, setPathname] = useState('');
	const { menusHistory, headerParentIds } = props;
	const { addParentId, addHeaderParentId, addCurrenmenu } = props;
	// 全剧监听 只为改变子应用容器是否显示
	history.listen((local) => {
		setPathname(local.pathname);
	});
	// 用户直接刷新/直接链接访问
	useEffect(() => {
		const { pathname, search } = window.location;
		const menu = menusHistory.find((item) => item.path.trim() === (pathname + search).trim());
		openView({
			path: (pathname + search).trim(),
			name: menu?.name,
			parentId: menu?.parentId
		});
		setPathname(pathname);
	}, []); // eslint-disable-line react-hooks/exhaustive-deps
	// 收缩展开
	const [collapsed, setCollapsed] = useState(false);

	const onCollapse = () => {
		setCollapsed(!collapsed);
	};
	// header选择
	const [headerSelectKey, setHeaderSelectKey] = useState('');

	const headerSelect = (e) => {
		setHeaderSelectKey(e.key);
		addHeaderParentId(e.key);
		addParentId([]);
		// if (localStorage.getItem('myWorkplat').includes('1276005')) {
		// 	let obj = {
		// 		path: '/zeus-system/system-permissions/workingPlatform',
		// 		name: '我的工作台',
		// 		parentId: '523523270839386118'
		// 	};
		// 	openView(obj);
		// 	addMenusHistory([obj]);
		// } else {
		// 	history.push('/');
		// 	addMenusHistory([]);
		// }
		addCurrenmenu('');
	};
	// 初始化状态
	useEffect(() => {
		addParentId([]);
	}, [headerSelectKey, headerParentIds]); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<ConfigProvider locale={zhCN}>
			<div className="App">
				<Headers headerSelect={headerSelect} headerSelectKey={headerSelectKey} />
				<div id="container">
					<Sidebar className="sildebar" collapsed={collapsed} headerSelectKey={headerSelectKey} />
					<div className="mainContainer">
						<Breadcremb collapsed={collapsed} onCollapse={onCollapse} />
						<div id="container-apps" style={{ width: collapsed ? ' calc(100vw - 64px)' : 'calc(100vw - 220px)' }}>
							{microApp.map((item) => (
								<div
									key={item.name}
									id={item.container.slice(1)}
									style={{
										display: pathname.startsWith(item.prefixPath) ? 'block' : 'none',
										padding: specialPage ? '0px' : '24px',
										overflow: isShowFlow ? 'hidden' : 'auto'
									}}></div>
							))}
						</div>
					</div>
				</div>
			</div>
		</ConfigProvider>
	);
}
const mapStateToProps = (state) => {
	return {
		menusHistory: state.menusHistory,
		menus: state.menus,
		headerParentIds: state.headerParentIds
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		saveArticle: (article) => dispatch({ type: 'ADD_ARTICLE', article }),
		addMenusHistory: (info) => dispatch({ type: 'ADD_MENUSHISTORY', info }),
		addParentId: (info) => dispatch({ type: 'ADD_PARENTID', info }),
		addHeaderParentId: (info) => dispatch({ type: 'ADD_HEADERPARENTID', info }),
		addCurrenmenu: (info) => dispatch({ type: 'ADD_CURRENMENU', info })
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(App);
